import HistoricalMaps from "./historical-maps.json";

export default HistoricalMaps;
